import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

import { ScrollbarModule } from 'src/@fury/shared/scrollbar/scrollbar.module';
import { AvatarDisplayModule } from 'src/app/modules/avatar/avatar-display/avatar-display.module';
import { UserClientFormAutoCompleteModule } from 'src/app/generated/ui/chipList/UserClient/UserClient.module';

import { ActRequestMessageComponent } from './act-request-message.component';

@NgModule({
  declarations: [ActRequestMessageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MaterialModule,
    MatSidenavModule,
    MatCardModule,
    MatDividerModule,

    ScrollbarModule,

    AvatarDisplayModule,
    UserClientFormAutoCompleteModule
  ],
  exports: [ActRequestMessageComponent]
})
export class ActRequestMessageModule {}
